import { gql } from '@apollo/client';

export const CatalogInfosFragment = gql`
  fragment CatalogInfos on Services {
    itemCount
    privateItemCount
    publicItemCount
  }
`;
